import React from 'react';
import { compose } from "redux";
import PropTypes from 'prop-types';
import { PageNavLink } from 'components/PageStyles';
import { withTheme } from 'styled-components';
import { featureKeys } from 'services/FeatureFlagService';
import PearsonInterrobang from 'components/PearsonInterrobang';
import PearsonInterrobangMonochrome from 'components/PearsonInterrobang/MonochromeIcon';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';
import {
  NavLogo,
  BetaTag,
} from './styles';
import { BRONTE_BETA_STORAGE_KEY } from 'constants/constants';

export const NavBrand = ({ theme, getFeatureFlagValue }) => {
  const isBeta = localStorage.getItem(BRONTE_BETA_STORAGE_KEY) === "true" ? true : false;

  const Logo = (theme && theme.themeId === 'extra-light')
    ? PearsonInterrobang
    : PearsonInterrobangMonochrome;
  
  const isRedesignedWorkspaceNew = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);
  
  const logoClickHandler = () => window.location.href = '/recent';

  const workspaceRedesignBrand = () => (<PageNavLink to="/recent" onClick={logoClickHandler} aria-label="aero">
    <NavLogo newUX={true}>
      { intl.formatMessage(messages.logoName) }
      {isBeta && <BetaTag newUX={true}>{intl.formatMessage(messages.logoTag)}</BetaTag>}
    </NavLogo>
  </PageNavLink>
  );

  if(isRedesignedWorkspaceNew) {
    return workspaceRedesignBrand();
  }

  return (
    <PageNavLink to="/" aria-label="aero">
      <NavLogo>
        <Logo style={{ transform: 'scale(0.9)' }} />
        {isBeta && <BetaTag>{intl.formatMessage(messages.logoTag)}</BetaTag>}
      </NavLogo>
    </PageNavLink>
  );
};

NavBrand.propTypes = {
  theme: PropTypes.object,
};

const flagNames = [featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default compose(withTheme, enhanceWithFeatureFlagSubscription)(NavBrand, flagNames);
